import { IAppState } from '../../redux';

export function selectSkipHash(state: IAppState): string | null {
  return state.visibleViolations.skipHash;
}
